<template>
  <section class="dp-layout dorm-module dorm-building-attendance">
    <aside class="dp-left dorm-building-sidebar">
      <div class="sidebar-head">
        <div>
          <strong>宿舍楼栋</strong>
          <span>{{ buildings.length }} 栋</span>
        </div>
        <i class="el-icon-office-building" />
      </div>

      <el-input v-model="buildingKeyword" size="small" clearable prefix-icon="el-icon-search" placeholder="搜索楼栋" />

      <div v-loading="buildingLoading" class="building-list">
        <div class="building-item all-building" :class="{ active: isAllBuildingsSelected }"
          @click="selectAllBuildings">
          <div class="building-item-title">
            <span>全部楼栋</span>
            <i class="el-icon-s-grid" />
          </div>
          <div class="building-item-meta">
            <span>{{ residentTypeName }} {{ totalSummary.ResidentCount || 0 }}</span>
            <span :class="{ danger: abnormalCount(totalSummary) > 0 }">问题 {{ abnormalCount(totalSummary) }}</span>
          </div>
          <div class="building-item-meta muted">
            <span>{{ attendanceTab === 'morning' ? '离寝未判定' : '归寝未判定' }} {{ tabUnjudgedCount(totalSummary) }}</span>
          </div>
        </div>

        <div v-for="building in filteredBuildings" :key="building.BuildingId" class="building-item"
          :class="{ active: isBuildingSelected(building) }" @click="selectBuilding(building)">
          <div class="building-item-title">
            <span>{{ building.BuildingName || building.Name || '未命名楼栋' }}</span>
            <i class="el-icon-arrow-right" />
          </div>
          <div class="building-item-meta">
            <span>{{ residentTypeName }} {{ building.ResidentCount || 0 }}</span>
            <span :class="{ danger: abnormalCount(building) > 0 }">问题 {{ abnormalCount(building) }}</span>
          </div>
          <div class="building-item-meta muted">
            <span>{{ attendanceTab === 'morning' ? '离寝未判定' : '归寝未判定' }} {{ tabUnjudgedCount(building) }}</span>
          </div>
        </div>

        <div v-if="!buildingLoading && !filteredBuildings.length" class="empty-building">
          暂无可查看楼栋
        </div>
      </div>
    </aside>

    <main class="dp-right dorm-card building-main">
      <div class="building-toolbar">
        <div>
          <div class="scope-title">
            <i class="el-icon-office-building" />
            <strong>{{ selectedTitle }}</strong>
          </div>
          <div class="scope-subtitle">
            {{ summary.DataModeDescription || '树形统计由服务端汇总；学生明细点击后分页查询，查询不会补判或写库。' }}
          </div>
        </div>
        <div class="toolbar-actions">
          <el-date-picker v-model="attendanceDate" type="date" value-format="yyyy-MM-dd" size="small" :clearable="false"
            @change="attendanceTabManual = false; loadBuildings(true)" />
          <el-button size="small" type="primary" icon="el-icon-refresh" :loading="buildingLoading"
            @click="loadBuildings(true)">
            刷新
          </el-button>
          <el-radio-group v-model="attendanceTab" size="mini" class="attendance-tab-switch" @change="attendanceTabManual = true">
            <el-radio-button label="morning">离寝</el-radio-button>
            <el-radio-button label="evening">归寝</el-radio-button>
          </el-radio-group>
        </div>
      </div>

      <div v-loading="buildingLoading" class="building-content">
        <div class="building-mode-tip">
          <span :class="['mode-dot', isRealtime ? 'realtime' : 'history']" />
          {{ isRealtime ? '当天实时' : '历史日报' }}
          <span class="mode-time">统计服务端汇总；点击楼栋、楼层、房间弹窗查看学生明细</span>
        </div>

        <section class="summary-block" :class="{ 'is-collapsed': summaryBlockCollapsed }">
          <div class="summary-block-head" @click="summaryBlockCollapsed = !summaryBlockCollapsed">
            <div class="summary-block-title">
              <i :class="summaryBlockCollapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'" />
              <strong>{{ selectedTitle }}</strong>
            </div>
            <span class="summary-link" @click.stop="openScopeDetail('')">{{ residentTypeName }} {{ (currentSummary.ResidentCount || 0) }}</span>
          </div>
          <div v-show="!summaryBlockCollapsed" class="summary-block-body">
            <div class="metric-groups">
              <div v-for="group in metricGroups" v-if="group.key === 'presence' || group.key === 'other' || group.key === attendanceTab"
                :key="group.key" class="metric-group" :class="group.key">
                <div class="metric-group-head">
                  <strong>{{ group.title }}</strong>
                  <span v-if="group.tip">{{ group.tip }}</span>
                </div>
                <div class="metric-grid building-metrics" :style="{ '--metric-cols': group.cards.length }">
                  <div v-for="card in group.cards" :key="card.key || card.label" class="metric-card"
                    :class="{ disabled: card.disabled }" @click="openScopeDetail(card.key)">
                    <em>{{ card.label }}</em>
                    <b :class="card.tone">{{ card.value }}</b>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="scope-summary">
          <div class="section-head">
            <div>
              <strong>楼栋明细</strong>
              <span>{{ isAllBuildingsSelected ? '按楼栋、楼层、房间树形展示' : '按楼层、房间树形展示' }}</span>
            </div>
          </div>
          <div class="scope-table-host tbl-scroll-host">
            <el-table :data="treeRows" row-key="key" size="small" class="scope-table" empty-text="暂无楼栋、楼层或房间数据"
              height="100%" style="width: 100%;" :tree-props="{ children: 'children' }" @row-click="openRowDetail">
              <el-table-column prop="name" :label="isAllBuildingsSelected ? '楼栋 / 楼层 / 房间' : '楼层 / 房间'"
                min-width="180" show-overflow-tooltip>
            <template slot-scope="scope">
              <span class="scope-name" :class="scope.row.level">
                <i :class="scopeIcon(scope.row.level)" />
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="ResidentCount" :label="residentTypeName" min-width="90" align="center" show-overflow-tooltip />
          <el-table-column label="实时位置" align="center">
            <el-table-column label="在寝" min-width="62" align="center">
              <template slot-scope="scope">
                <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'IN_DORM')">{{
                  presenceCell(scope.row.InDormCount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="出寝" min-width="62" align="center">
              <template slot-scope="scope">
                <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'OUT_DORM')">{{
                  presenceCell(scope.row.OutDormCount) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="无通行" min-width="72" align="center">
              <template slot-scope="scope">
                <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'UNJUDGED_PRESENCE')">{{
                  presenceCell(tabUnjudgedPresenceCount(scope.row)) }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="attendanceTab === 'morning'" label="离寝" align="center">
            <el-table-column prop="MorningExitedCount" label="合计" min-width="76" align="center">
            <template slot-scope="scope">
              <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'EXITED_OR_LATE')">
                {{ scope.row.MorningExitedCount != null ? scope.row.MorningExitedCount : ((scope.row.MorningNormalCount
                  || 0) + (scope.row.MorningLateExitCount || 0)) }}
              </span>
            </template>
            </el-table-column>
            <el-table-column prop="MorningNotExitedCount" label="未离寝" min-width="76" align="center">
            <template slot-scope="scope">
              <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'NOT_EXITED')">{{
                scope.row.MorningNotExitedCount || 0 }}</span>
            </template>
            </el-table-column>
            <el-table-column prop="MorningLateExitCount" label="晚离" min-width="64" align="center">
            <template slot-scope="scope">
              <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'LATE_EXIT')">{{
                scope.row.MorningLateExitCount || 0 }}</span>
            </template>
            </el-table-column>
          </el-table-column>
          <el-table-column v-if="attendanceTab === 'evening'" label="归寝" align="center">
            <el-table-column prop="EveningReturnedCount" label="合计" min-width="76" align="center">
            <template slot-scope="scope">
              <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'RETURNED_OR_LATE')">
                {{ scope.row.EveningReturnedCount != null ? scope.row.EveningReturnedCount :
                  ((scope.row.EveningNormalCount || 0) + (scope.row.EveningLateReturnCount || 0)) }}
              </span>
            </template>
            </el-table-column>
            <el-table-column prop="EveningNotReturnedCount" label="未归寝" min-width="76" align="center">
            <template slot-scope="scope">
              <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'NOT_RETURNED')">{{
                scope.row.EveningNotReturnedCount || 0 }}</span>
            </template>
            </el-table-column>
            <el-table-column prop="EveningLateReturnCount" label="晚归" min-width="64" align="center">
            <template slot-scope="scope">
              <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'LATE_RETURN')">{{
                scope.row.EveningLateReturnCount || 0 }}</span>
            </template>
            </el-table-column>
            <el-table-column prop="EveningOvertimeReturnCount" label="超时归寝" min-width="82" align="center" />
            <el-table-column prop="EveningReturnedThenExitedCount" label="归寝后离寝" min-width="92" align="center" />
          </el-table-column>
          <el-table-column label="其他" align="center">
            <el-table-column prop="LeaveCount" label="请假" min-width="64" align="center">
            <template slot-scope="scope">
              <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'LEAVE')">{{
                attendanceTab === 'morning'
                  ? (scope.row.MorningLeaveCount || 0)
                  : (scope.row.EveningLeaveCount || 0) }}</span>
            </template>
            </el-table-column>
            <el-table-column prop="UnjudgedCount" :label="attendanceTab === 'morning' ? '离寝未判定' : '归寝未判定'" min-width="96" align="center">
            <template slot-scope="scope">
              <span class="metric-link" @click.stop="openRowMetricDetail(scope.row, 'UNJUDGED')">{{
                tabUnjudgedCount(scope.row) }}</span>
            </template>
            </el-table-column>
          </el-table-column>
            </el-table>
          </div>
        </section>
      </div>
    </main>

    <el-dialog :title="detailDialogTitle" :visible.sync="detailVisible" width="920px"
      custom-class="metric-detail-dialog building-detail-dialog" append-to-body>
      <div class="detail-toolbar">
        <el-input v-model="studentKeyword" class="detail-search-input" size="small" clearable
          prefix-icon="el-icon-search" placeholder="搜索姓名、班级" @keyup.enter.native="loadDetailRows(1)" />
        <el-button size="small" type="primary" icon="el-icon-search" @click="loadDetailRows(1)">搜索</el-button>
        <el-button v-if="detailFilter" size="small" @click="clearDetailFilter">清除状态筛选</el-button>
      </div>

      <div class="metric-detail-table-wrap">
        <el-table v-loading="detailLoading" :data="detailRows" size="small" class="metric-detail-table"
          empty-text="暂无学生明细" height="100%">
        <el-table-column label="头像" width="56" align="center">
          <template slot-scope="scope">
            <oss-el-image v-if="scope.row.HeadPhotoImage" :src="scope.row.HeadPhotoImage"
              :preview-src-list="[scope.row.HeadPhotoImage]" fit="cover" class="student-photo">
              <div slot="error" class="student-photo-error">
                <i class="el-icon-picture-outline" />
              </div>
            </oss-el-image>
            <span v-else class="student-avatar">{{ studentInitial(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="StudentName" label="学生" width="100" show-overflow-tooltip />
        <el-table-column prop="ClassName" label="班级" min-width="118" show-overflow-tooltip />
        <el-table-column label="入住信息" min-width="168" show-overflow-tooltip>
          <template slot-scope="scope">{{ roomDisplay(scope.row) }}</template>
        </el-table-column>
        <el-table-column label="实时位置" width="96" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="presenceTagType(scope.row.PresenceStatus)">
              {{ presenceName(scope.row.PresenceStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="attendanceTab === 'morning' ? '离寝' : '归寝'" min-width="110" align="center">
          <template slot-scope="scope">
            <el-tag v-if="attendanceTab === 'morning'" size="mini"
              :type="resultTagType(scope.row.MorningResult)" :class="resultTagClass(scope.row.MorningResult)">
              {{ resultName(scope.row.MorningResult, scope.row, 'MORNING_EXIT') }}
            </el-tag>
            <template v-else>
              <el-tag size="mini" :type="resultTagType(scope.row.EveningResult)"
                :class="resultTagClass(scope.row.EveningResult)">
                {{ resultName(scope.row.EveningResult, scope.row, 'EVENING_RETURN') }}
              </el-tag>
              <el-tag v-if="scope.row.EveningReturnedThenExitedAt" size="mini" type="danger" class="review-detail-tag">
                需复核
              </el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="最后门禁" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ formatTime(scope.row.LastEventTime) }}</template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-wrap detail-pager">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="detailPage"
          :page-size="detailPageSize" :page-sizes="[10, 20, 50, 100]" :total="detailTotal"
          @size-change="handleDetailPageSizeChange" @current-change="loadDetailRows" />
      </div>
      <div slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getDormAttendanceV3BuildingTreeSummary, getDormAttendanceV3Details } from '../../api/modules/dormitory'
import { getUnifiedPageSize, setUnifiedPageSize } from '../../utils/elPaginationUnify'
import '../../styles/dorm-module.css'

export default {
  name: 'DormBuildingAttendance',
  data() {
    return {
      summaryBlockCollapsed: false,
      attendanceTab: 'morning',
      attendanceTabManual: false,
      schoolId: '',
      residentTypeName: '入住人数',
      attendanceDate: this.today(),
      buildingKeyword: '',
      studentKeyword: '',
      searchTimer: null,
      summary: { DataMode: '', DataModeDescription: '', Total: {}, Buildings: [] },
      buildings: [],
      treeNodes: [],
      selectedBuildingId: 0,
      selectedBuilding: {},
      buildingLoading: false,
      detailVisible: false,
      detailLoading: false,
      detailRows: [],
      detailTotal: 0,
      detailPage: 1,
      detailPageSize: getUnifiedPageSize(),
      detailDialogTitle: '',
      detailScope: null,
      detailFilter: '',
      detailRequestSeq: 0,
      buildingRequestSeq: 0
    }
  },
  computed: {
    isRealtime() {
      return this.summary.DataMode === 'REALTIME'
    },
    totalSummary() {
      return this.summary.Total || {}
    },
    selectedTitle() {
      return this.isAllBuildingsSelected ? '全部楼栋统计' : (this.selectedBuilding.BuildingName || this.selectedBuilding.Name || '宿舍楼栋统计')
    },
    currentSummary() {
      if (this.isAllBuildingsSelected) return this.totalSummary
      return this.buildings.find(item => this.isBuildingSelected(item)) || {}
    },
    isAllBuildingsSelected() {
      return String(this.selectedBuildingId || 0) === '0'
    },
    filteredBuildings() {
      const keyword = (this.buildingKeyword || '').trim().toLowerCase()
      if (!keyword) return this.buildings
      return this.buildings.filter(item => String(item.BuildingName || item.Name || '').toLowerCase().includes(keyword))
    },
    metricGroups() {
      const s = this.currentSummary || {}
      return [
        {
          key: 'presence',
          title: '实时位置',
          tip: this.isRealtime ? '按当天最后一条有效门禁流水' : '历史日期不显示实时位置',
          cards: [
            { key: '', label: this.residentTypeName, value: s.ResidentCount || 0, tone: '' },
            { key: 'IN_DORM', label: '在寝', value: this.isRealtime ? (s.InDormCount || 0) : '-', tone: 'ok', disabled: !this.isRealtime },
            { key: 'OUT_DORM', label: '出寝', value: this.isRealtime ? (s.OutDormCount || 0) : '-', tone: 'warn', disabled: !this.isRealtime },
            {
              key: 'UNJUDGED_PRESENCE',
              label: '无通行',
              value: this.isRealtime ? this.tabUnjudgedPresenceCount(s) : '-',
              tone: 'wait',
              disabled: !this.isRealtime
            }
          ]
        },
        {
          key: 'morning',
          title: '离寝考勤',
          tip: this.isRealtime && s.MorningSettlementTime
            ? `当天离寝截止 ${String(s.MorningSettlementTime).substring(0, 5)}`
            : '',
          cards: [
            { key: 'EXITED_OR_LATE', label: '离寝合计', value: s.MorningExitedCount != null ? s.MorningExitedCount : ((s.MorningNormalCount || 0) + (s.MorningLateExitCount || 0)), tone: 'ok' },
            { key: 'NOT_EXITED', label: '未离寝', value: s.MorningNotExitedCount || 0, tone: 'bad' },
            { key: 'LATE_EXIT', label: '晚离', value: s.MorningLateExitCount || 0, tone: 'bad' }
          ]
        },
        {
          key: 'evening',
          title: '归寝考勤',
          tip: this.isRealtime && s.EveningSettlementTime
            ? `当天归寝截止 ${String(s.EveningSettlementTime).substring(0, 5)}`
            : '',
          cards: [
            { key: 'RETURNED_OR_LATE', label: '归寝合计', value: s.EveningReturnedCount != null ? s.EveningReturnedCount : ((s.EveningNormalCount || 0) + (s.EveningLateReturnCount || 0)), tone: 'ok' },
            { key: 'NOT_RETURNED', label: '未归寝', value: s.EveningNotReturnedCount || 0, tone: 'bad' },
            { key: 'LATE_RETURN', label: '晚归', value: s.EveningLateReturnCount || 0, tone: 'bad' },
            { key: 'OVERTIME_RETURN', label: '超时归寝', value: s.EveningOvertimeReturnCount || 0, tone: 'bad' },
            { key: 'RETURNED_THEN_EXITED', label: '归寝后离寝', value: s.EveningReturnedThenExitedCount || 0, tone: 'bad' }
          ]
        },
        {
          key: 'other',
          title: '其他',
          tip: '请假与考勤资格',
          cards: [
            {
              key: 'LEAVE',
              label: '请假',
              value: this.attendanceTab === 'morning'
                ? (s.MorningLeaveCount || 0)
                : (s.EveningLeaveCount || 0),
              tone: ''
            },
            {
              key: 'UNJUDGED',
              label: this.attendanceTab === 'morning' ? '离寝未判定' : '归寝未判定',
              value: this.tabUnjudgedCount(s),
              tone: 'wait'
            }
          ]
        }
      ]
    },
    treeRows() {
      if (this.isAllBuildingsSelected) return this.treeNodes
      const selected = this.treeNodes.find(item => this.isBuildingSelected(item))
      return selected ? (selected.children || []) : []
    }
  },
  watch: {
    '$store.state.activeSchoolId': {
      handler(value, oldValue) {
        if (value == null || String(value) === String(oldValue)) return
        this.handleGlobalSchoolChange(value)
      }
    },
    studentKeyword() {
      if (!this.detailVisible) return
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => this.loadDetailRows(1), 300)
    }
  },
  mounted() {
    this.schoolId = (this.$store && this.$store.state && this.$store.state.activeSchoolId) || window.localStorage.getItem('activeSchoolId') || ''
    this.loadResidentTypeName()
    this.loadBuildings(false, true)
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer)
  },
  methods: {
    async loadResidentTypeName() {
      this.residentTypeName = '入住人数'
    },
    today() {
      const d = new Date()
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    },
    handleGlobalSchoolChange(value) {
      const nextSchoolId = String(value || '')
      if (!nextSchoolId || nextSchoolId === String(this.schoolId || '')) return
      this.schoolId = nextSchoolId
      this.loadResidentTypeName()
      this.buildingRequestSeq += 1
      this.detailRequestSeq += 1
      this.summary = { DataMode: '', DataModeDescription: '', Total: {}, Buildings: [] }
      this.buildings = []
      this.treeNodes = []
      this.selectedBuildingId = 0
      this.selectedBuilding = {}
      this.detailScope = null
      this.detailVisible = false
      this.detailRows = []
      this.detailTotal = 0
      this.loadBuildings(false, false)
    },
    async loadBuildings(keepSelection, allowRouteSelection) {
      if (!this.schoolId) return
      const schoolId = String(this.schoolId)
      const requestSeq = ++this.buildingRequestSeq
      this.buildingLoading = true
      try {
        const response = await getDormAttendanceV3BuildingTreeSummary({
          departmentId: schoolId,
          attendanceDate: this.attendanceDate,
          includeDetails: false
        })
        if (requestSeq !== this.buildingRequestSeq || String(this.schoolId) !== schoolId) return
        const data = (response.data && response.data.response) || {}
        const nodes = (data.Buildings || []).map(this.normalizeNode)
        this.summary = {
          ...data,
          Total: data.Total ? this.normalizeNode(data.Total) : {},
          Buildings: nodes
        }
        if (!this.attendanceTabManual && (data.DefaultAttendanceTab === 'morning' || data.DefaultAttendanceTab === 'evening')) {
          this.attendanceTab = data.DefaultAttendanceTab
        }
        this.treeNodes = nodes
        this.buildings = nodes

        const queryBuildingId = Number(this.$route.query.buildingId || 0)
        if (allowRouteSelection && !keepSelection && queryBuildingId > 0) {
          const selected = this.buildings.find(item => Number(item.BuildingId || 0) === queryBuildingId)
          if (selected) this.selectBuilding(selected)
          else this.selectAllBuildings()
        } else if (keepSelection && !this.isAllBuildingsSelected) {
          this.selectedBuilding = this.buildings.find(item => this.isBuildingSelected(item)) || {}
          if (!this.selectedBuilding.BuildingId) this.selectAllBuildings()
          else this.loadBuildingDetails(this.selectedBuildingId)
        } else {
          this.selectAllBuildings()
        }
      } finally {
        if (requestSeq === this.buildingRequestSeq) this.buildingLoading = false
      }
    },
    normalizeNode(node) {
      const buildingId = node.BuildingId || node.buildingId || 0
      const floorId = node.FloorId || node.floorId || 0
      const roomId = node.RoomId || node.roomId || 0
      const buildingName = node.BuildingName || node.buildingName || ''
      const floorName = node.FloorName || node.floorName || ''
      const roomName = node.RoomName || node.roomName || ''
      const normalized = {
        ...node,
        key: node.Key || node.key,
        level: node.Level || node.level,
        name: node.Name || node.name,
        BuildingId: buildingId,
        BuildingName: buildingName,
        FloorId: floorId,
        FloorName: floorName,
        RoomId: roomId,
        RoomName: roomName,
        ResidentCount: node.ResidentCount || node.residentCount || 0,
        InDormCount: node.InDormCount || node.inDormCount || 0,
        OutDormCount: node.OutDormCount || node.outDormCount || 0,
        UnknownPresenceCount: node.UnknownPresenceCount || node.unknownPresenceCount || 0,
        UnjudgedPresenceCount: node.UnjudgedPresenceCount || node.unjudgedPresenceCount || node.UnknownPresenceCount || node.unknownPresenceCount || 0,
        MorningUnjudgedPresenceCount: node.MorningUnjudgedPresenceCount || node.morningUnjudgedPresenceCount || 0,
        EveningUnjudgedPresenceCount: node.EveningUnjudgedPresenceCount || node.eveningUnjudgedPresenceCount || 0,
        MorningNotExitedCount: node.MorningNotExitedCount || node.morningNotExitedCount || 0,
        MorningLateExitCount: node.MorningLateExitCount || node.morningLateExitCount || 0,
        MorningAbnormalCount: node.MorningAbnormalCount || node.morningAbnormalCount || 0,
        EveningNotReturnedCount: node.EveningNotReturnedCount || node.eveningNotReturnedCount || 0,
        EveningLateReturnCount: node.EveningLateReturnCount || node.eveningLateReturnCount || 0,
        EveningAbnormalCount: node.EveningAbnormalCount || node.eveningAbnormalCount || 0,
        LeaveCount: node.LeaveCount != null ? node.LeaveCount : (node.AnyLeaveStudentCount || node.anyLeaveStudentCount || 0),
        AnyLeaveStudentCount: node.AnyLeaveStudentCount || node.anyLeaveStudentCount || node.LeaveCount || node.leaveCount || 0,
        MorningLeaveCount: node.MorningLeaveCount || node.morningLeaveCount || 0,
        EveningLeaveCount: node.EveningLeaveCount || node.eveningLeaveCount || 0,
        UnjudgedCount: node.UnjudgedCount || node.unjudgedCount || 0,
        MorningUnjudgedCount: node.MorningUnjudgedCount || node.morningUnjudgedCount || 0,
        EveningUnjudgedCount: node.EveningUnjudgedCount || node.eveningUnjudgedCount || 0,
        NotCheckedInCount: node.NotCheckedInCount || node.notCheckedInCount || 0,
        NotApplicableCount: node.NotApplicableCount || node.notApplicableCount || 0,
        buildingId,
        buildingName,
        floorId,
        floorName,
        roomId,
        roomName,
        children: []
      }
      normalized.Children = node.Children || node.children || []
      normalized.children = normalized.Children.map(this.normalizeNode)
      return normalized
    },
    selectAllBuildings() {
      this.selectedBuildingId = 0
      this.selectedBuilding = {}
      this.detailScope = null
    },
    /**
     * 判断左侧楼栋卡片是否为当前选中项。用字符串比较，避免接口 ID 类型不一致导致选中态丢失。
     */
    isBuildingSelected(building) {
      if (!building || this.isAllBuildingsSelected) return false
      const id = building.BuildingId || building.buildingId || 0
      return String(id) === String(this.selectedBuildingId)
    },
    selectBuilding(building) {
      this.selectedBuilding = building || {}
      this.selectedBuildingId = this.selectedBuilding.BuildingId || this.selectedBuilding.buildingId || 0
      this.detailScope = null
      if (String(this.selectedBuildingId || 0) !== '0') this.loadBuildingDetails(this.selectedBuildingId)
    },
    async loadBuildingDetails(buildingId) {
      if (!buildingId || !this.schoolId) return
      const schoolId = String(this.schoolId)
      const requestSeq = ++this.buildingRequestSeq
      this.buildingLoading = true
      try {
        const response = await getDormAttendanceV3BuildingTreeSummary({
          departmentId: schoolId,
          attendanceDate: this.attendanceDate,
          buildingId,
          includeDetails: true
        })
        if (requestSeq !== this.buildingRequestSeq || String(this.schoolId) !== schoolId) return
        const data = (response.data && response.data.response) || {}
        const rawNode = (data.Buildings || [])[0]
        if (!rawNode) return
        const node = this.normalizeNode(rawNode)
        const index = this.buildings.findIndex(item => String(item.BuildingId || item.buildingId || 0) === String(buildingId))
        if (index >= 0) {
          this.$set(this.buildings, index, node)
          this.$set(this.treeNodes, index, node)
        }
        if (String(this.selectedBuildingId) === String(buildingId)) this.selectedBuilding = node
        if (data.DataMode) this.summary.DataMode = data.DataMode
        if (data.DataModeDescription) this.summary.DataModeDescription = data.DataModeDescription
      } finally {
        if (requestSeq === this.buildingRequestSeq) this.buildingLoading = false
      }
    },
    openRowDetail(row) {
      if (!row) return
      this.detailScope = row
      this.detailFilter = ''
      this.studentKeyword = ''
      this.detailPage = 1
      this.detailDialogTitle = `${this.attendanceDate} · ${this.scopeLabel(row)} · 学生明细`
      this.resetDetailState()
      this.detailVisible = true
      this.$nextTick(() => this.loadDetailRows(1))
    },
    openScopeDetail(filter) {
      if (filter && ['IN_DORM', 'OUT_DORM', 'UNJUDGED_PRESENCE'].includes(filter) && !this.isRealtime) return
      this.detailScope = this.isAllBuildingsSelected ? null : this.currentSummary
      this.detailFilter = filter || ''
      this.studentKeyword = ''
      this.detailPage = 1
      this.detailDialogTitle = `${this.attendanceDate} · ${this.selectedTitle} · ${filter ? this.filterName(filter) : '全部学生'}`
      this.resetDetailState()
      this.detailVisible = true
      this.$nextTick(() => this.loadDetailRows(1))
    },
    openRowMetricDetail(row, filter) {
      if (!row || !filter) return
      if (['IN_DORM', 'OUT_DORM', 'UNJUDGED_PRESENCE'].includes(filter) && !this.isRealtime) return
      this.detailScope = row
      this.detailFilter = filter
      this.studentKeyword = ''
      this.detailPage = 1
      this.detailDialogTitle = `${this.attendanceDate} · ${this.scopeLabel(row)} · ${this.filterName(filter)}`
      this.resetDetailState()
      this.detailVisible = true
      this.$nextTick(() => this.loadDetailRows(1))
    },
    clearDetailFilter() {
      this.detailFilter = ''
      this.detailDialogTitle = `${this.attendanceDate} · ${this.detailScope ? this.scopeLabel(this.detailScope) : this.selectedTitle} · 全部学生`
      this.loadDetailRows(1)
    },
    resetDetailState() {
      this.detailRequestSeq += 1
      this.detailRows = []
      this.detailTotal = 0
      this.detailLoading = true
    },
    async loadDetailRows(page) {
      if (!this.detailVisible || !this.schoolId) return
      const requestSeq = ++this.detailRequestSeq
      this.detailPage = page || 1
      this.detailLoading = true
      try {
        const params = {
          departmentId: this.schoolId,
          attendanceDate: this.attendanceDate,
          page: this.detailPage,
          intPageSize: this.detailPageSize,
          name: (this.studentKeyword || '').trim()
        }
        const scope = this.detailScope || {}
        if (scope.BuildingId || scope.buildingId) params.buildingId = scope.BuildingId || scope.buildingId
        if (scope.FloorId || scope.floorId) params.floorId = scope.FloorId || scope.floorId
        if (scope.RoomId || scope.roomId) params.roomId = scope.RoomId || scope.roomId
        this.applyDetailFilter(params)
        const response = await getDormAttendanceV3Details(params)
        if (requestSeq !== this.detailRequestSeq) return
        const pageData = (response.data && response.data.response) || {}
        this.detailRows = pageData.data || pageData.Data || []
        this.detailTotal = pageData.dataCount || pageData.DataCount || pageData.total || pageData.Total || 0
      } finally {
        if (requestSeq === this.detailRequestSeq) this.detailLoading = false
      }
    },
    handleDetailPageSizeChange(size) {
      const nextSize = Number(size) || 10
      setUnifiedPageSize(nextSize)
      this.detailPageSize = nextSize
      this.loadDetailRows(1)
    },
    applyDetailFilter(params) {
      if (!this.detailFilter) return
      if (['IN_DORM', 'OUT_DORM'].includes(this.detailFilter)) {
        params.presenceStatus = this.detailFilter
      } else if (this.detailFilter === 'UNJUDGED_PRESENCE') {
        params.presenceStatus = 'UNJUDGED'
        params.attendanceItem = this.attendanceTab === 'morning' ? 'MORNING_EXIT' : 'EVENING_RETURN'
      } else if (this.detailFilter === 'EXITED_OR_LATE') {
        params.attendanceItem = 'MORNING_EXIT'
        params.result = 'EXITED_OR_LATE'
      } else if (this.detailFilter === 'NOT_EXITED') {
        params.attendanceItem = 'MORNING_EXIT'
        params.result = 'NOT_EXITED'
      } else if (this.detailFilter === 'LATE_EXIT') {
        params.attendanceItem = 'MORNING_EXIT'
        params.result = 'LATE_EXIT'
      } else if (this.detailFilter === 'NOT_RETURNED') {
        params.attendanceItem = 'EVENING_RETURN'
        params.result = 'NOT_RETURNED'
      } else if (this.detailFilter === 'RETURNED_OR_LATE') {
        params.attendanceItem = 'EVENING_RETURN'
        params.result = 'RETURNED_OR_LATE'
      } else if (this.detailFilter === 'LATE_RETURN') {
        params.attendanceItem = 'EVENING_RETURN'
        params.result = 'LATE_RETURN'
      } else if (this.detailFilter === 'OVERTIME_RETURN') {
        params.attendanceItem = 'EVENING_RETURN'
        params.result = 'OVERTIME_RETURN'
      } else if (this.detailFilter === 'RETURNED_THEN_EXITED') {
        params.attendanceItem = 'EVENING_RETURN'
        params.result = 'RETURNED_THEN_EXITED'
      } else if (this.detailFilter === 'LEAVE') {
        params.attendanceItem = this.attendanceTab === 'morning' ? 'MORNING_EXIT' : 'EVENING_RETURN'
        params.result = 'LEAVE'
      } else if (this.detailFilter === 'UNJUDGED') {
        params.attendanceItem = this.attendanceTab === 'morning' ? 'MORNING_EXIT' : 'EVENING_RETURN'
        params.result = 'UNJUDGED'
      } else if (this.detailFilter === 'NOT_CHECKED_IN') {
        params.eligibilityStatus = 'NOT_CHECKED_IN'
      } else if (this.detailFilter === 'NOT_APPLICABLE') {
        params.eligibilityStatus = 'NOT_APPLICABLE'
      }
    },
    /**
     * 当前离/归 Tab 下的未判定人数。最后更新：2026-10-23
     */
    tabUnjudgedCount(row) {
      if (!row) return 0
      if (this.attendanceTab === 'morning') {
        return row.MorningUnjudgedCount != null ? row.MorningUnjudgedCount : (row.morningUnjudgedCount || 0)
      }
      return row.EveningUnjudgedCount != null ? row.EveningUnjudgedCount : (row.eveningUnjudgedCount || 0)
    },
    /**
     * 当前离/归 Tab 下的无通行人数（排除对应窗口请假）。最后更新：2026-10-28
     */
    tabUnjudgedPresenceCount(row) {
      if (!row) return 0
      if (this.attendanceTab === 'morning') {
        if (row.MorningUnjudgedPresenceCount != null) return row.MorningUnjudgedPresenceCount
        if (row.morningUnjudgedPresenceCount != null) return row.morningUnjudgedPresenceCount
      } else {
        if (row.EveningUnjudgedPresenceCount != null) return row.EveningUnjudgedPresenceCount
        if (row.eveningUnjudgedPresenceCount != null) return row.eveningUnjudgedPresenceCount
      }
      return row.UnjudgedPresenceCount || row.unjudgedPresenceCount || row.UnknownPresenceCount || row.unknownPresenceCount || 0
    },
    abnormalCount(row) {
      return (row.MorningAbnormalCount || 0) + (row.EveningAbnormalCount || 0)
    },
    presenceCell(value) {
      return this.isRealtime ? (value || 0) : '-'
    },
    scopeLabel(row) {
      const parts = [row.buildingName, row.floorName, row.roomName || row.name].filter(Boolean)
      return parts.length ? parts.join(' · ') : (row.name || this.selectedTitle)
    },
    roomDisplay(row) {
      const bedText = row && row.BedNumber ? `${row.BedNumber}床` : ''
      const parts = [row.BuildingName, row.FloorName, row.RoomName, bedText].filter(Boolean)
      return parts.length ? parts.join(' / ') : '未分配'
    },
    studentInitial(row) {
      return String(row.StudentName || '住').slice(0, 1)
    },
    presenceName(value) {
      return { IN_DORM: '在寝', OUT_DORM: '出寝', UNJUDGED: '无通行', HISTORY: '历史' }[value] || '无通行'
    },
    presenceTagType(value) {
      return value === 'IN_DORM' ? 'success' : value === 'OUT_DORM' ? 'warning' : 'info'
    },
    resultName(value, row, item) {
      if (value === 'EXITED') return '已离寝'
      if (value === 'RETURNED') return '已归寝'
      if (value === 'NOT_EXITED') return '未离寝'
      if (value === 'LATE_EXIT') return '晚离'
      if (value === 'NOT_RETURNED') return '未归寝'
      if (value === 'LATE_RETURN') return '晚归'
      if (value === 'LEAVE') return '请假'
      if (row && row.EligibilityStatus === 'NOT_APPLICABLE') return '无需考勤'
      if (row && row.EligibilityStatus === 'NOT_CHECKED_IN') return '未入住'
      return '未判定'
    },
    resultTagType(value) {
      if (['EXITED', 'RETURNED'].includes(value)) return 'success'
      if (['NOT_EXITED', 'LATE_EXIT', 'NOT_RETURNED', 'LATE_RETURN'].includes(value)) return 'warning'
      // 请假不用 warning，避免与问题态同色。最后更新：2026-09-14
      if (value === 'LEAVE') return ''
      return ''
    },
    resultTagClass(value) {
      return value === 'LEAVE' ? 'is-leave-tag' : ''
    },
    filterName(value) {
      return {
        IN_DORM: '在寝',
        OUT_DORM: '出寝',
        UNJUDGED_PRESENCE: '无通行',
        EXITED_OR_LATE: '离寝合计（含晚离）',
        NOT_EXITED: '未离寝',
        LATE_EXIT: '晚离',
        RETURNED_OR_LATE: '归寝合计（含晚归）',
        NOT_RETURNED: '未归寝',
        LATE_RETURN: '晚归',
        OVERTIME_RETURN: '超时归寝',
        RETURNED_THEN_EXITED: '归寝后离寝',
        LEAVE: '请假',
        UNJUDGED: this.attendanceTab === 'morning' ? '离寝未判定' : '归寝未判定',
        NOT_CHECKED_IN: '未入住',
        NOT_APPLICABLE: '无需考勤'
      }[value] || '全部学生'
    },
    scopeIcon(level) {
      return level === 'building' ? 'el-icon-office-building' : level === 'floor' ? 'el-icon-menu' : 'el-icon-house'
    },
    formatTime(value) {
      if (!value) return '-'
      const text = String(value)
      return text.length > 16 ? text.slice(0, 16).replace('T', ' ') : text.replace('T', ' ')
    }
  }
}
</script>

<style scoped>
.dorm-building-attendance {
  height: 100%;
  min-height: 0;
  overflow: hidden;
  color: #263548;
}

/* 请假标签：靛蓝，与未离寝等 warning 橙黄区分。最后更新：2026-09-14 */
.el-tag.is-leave-tag {
  background-color: #e0e7ff;
  border-color: #c7d2fe;
  color: #4338ca;
}

.dorm-building-sidebar {
  width: 200px;
  min-width: 200px;
  padding: 18px 14px;
  overflow: hidden;
}

.sidebar-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 4px 14px;
}

.sidebar-head strong {
  font-size: 16px;
}

.sidebar-head span {
  margin-left: 8px;
  color: #94a3b8;
  font-size: 12px;
}

.sidebar-head i {
  color: var(--btn-primary, #2563eb);
  font-size: 18px;
}

.building-list {
  height: calc(100% - 76px);
  margin-top: 12px;
  overflow: auto;
}

.building-item {
  padding: 13px 12px;
  margin-bottom: 8px;
  border: 1px solid #e8edf3;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: all .2s;
}

.building-item.all-building:not(.active) {
  background: #fbfdff;
}

.building-item:hover {
  border-color: #99f6e4;
  background: #f0fdfa;
}

.building-item.active,
.building-item.all-building.active {
  border-color: #0d9488;
  background: #ccfbf1;
  box-shadow: inset 3px 0 0 #0d9488;
}

.building-item.active .building-item-title,
.building-item.all-building.active .building-item-title {
  color: #0f766e;
}

.building-item-title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
}

.building-item-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  color: #475569;
  font-size: 12px;
}

.building-item-meta.muted {
  margin-top: 4px;
  color: #94a3b8;
}

.building-item-meta .danger {
  color: #ef4444;
}

.empty-building {
  padding: 60px 20px;
  color: #94a3b8;
  text-align: center;
}

.building-main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 12px 14px;
  overflow: hidden;
}

.building-toolbar {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eef2f7;
}

.scope-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
}

.scope-title i {
  color: var(--btn-primary, #2563eb);
}

.scope-subtitle {
  margin-top: 7px;
  color: #94a3b8;
  font-size: 12px;
}

.toolbar-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.building-content {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
}

.building-mode-tip {
  flex-shrink: 0;
  padding: 6px 0 2px;
  color: #64748b;
  font-size: 12px;
}

.mode-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 6px;
  border-radius: 50%;
  background: #94a3b8;
}

.mode-dot.realtime {
  background: #10b981;
}

.mode-dot.history {
  background: #64748b;
}

.mode-time {
  margin-left: 12px;
  color: #94a3b8;
}

.summary-block {
  flex-shrink: 0;
  padding: 0 2px 10px;
  border-bottom: 1px solid #e8ecf1;
}

.summary-block.is-collapsed {
  padding-bottom: 4px;
}

.summary-block-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
  user-select: none;
}

.summary-block.is-collapsed .summary-block-head {
  margin-bottom: 0;
}

.summary-block-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.summary-block-title i {
  flex-shrink: 0;
  color: #94a3b8;
  font-size: 12px;
}

.summary-block-head strong {
  font-size: 14px;
}

.summary-link {
  flex-shrink: 0;
  cursor: pointer;
  color: #64748b;
  font-size: 12px;
}

.summary-link:hover {
  color: #0d9488;
}

.metric-groups {
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr 1fr;
  gap: 10px;
}

.metric-group {
  min-width: 0;
  min-height: 104px;
  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid #e8ecf1;
  border-radius: 8px;
  background: #fff;
}

.metric-group.presence {
  background: #f8fffc;
  border-color: #d8f3e8;
}

/* 归寝有五项指标，单独占满一行，避免卡片被压缩成竖排。 */
.metric-group.evening {
  grid-column: span 2;
}

.metric-group-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.metric-group-head strong {
  color: #0f172a;
  font-size: 13px;
}

.metric-group-head span {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border: 1px solid #bfdbfe;
  border-radius: 4px;
  color: #1d4ed8;
  background: #eff6ff;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}

.building-metrics {
  display: grid;
  flex: 1;
  grid-template-columns: repeat(var(--metric-cols, 3), minmax(0, 1fr));
  gap: 8px;
  align-items: stretch;
}

.metric-card {
  min-height: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 10px 12px;
  border: 1px solid #edf1f5;
  border-radius: 6px;
  background: #f7f9fb;
  cursor: pointer;
  transition: background-color .16s ease, box-shadow .16s ease;
}

.metric-card:hover {
  border-color: #99f6e4;
  background: #fff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, .06);
}

.metric-card.disabled {
  cursor: default;
  opacity: .7;
}

.metric-card.disabled:hover {
  border-color: #edf1f5;
  background: #f7f9fb;
  box-shadow: none;
}

.metric-card em {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-style: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.metric-card b {
  display: block;
  margin-top: 6px;
  color: #334155;
  font-size: 20px;
  line-height: 1.2;
}

.metric-card b.ok {
  color: #16a34a;
}

.metric-card b.warn,
.metric-card b.wait {
  color: #d97706;
}

.metric-card b.bad {
  color: #dc2626;
}

/* 归寝包含五项指标，允许长标题换行，避免“超时归寝/归寝后离寝”被截断。 */
.metric-group.evening .metric-card {
  padding-left: 6px;
  padding-right: 6px;
}

.metric-group.evening .metric-card em {
  min-height: 30px;
  white-space: normal;
  line-height: 1.25;
}

.metric-link {
  color: #2563eb;
  cursor: pointer;
}

.metric-link:hover {
  text-decoration: underline;
}

.scope-summary {
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.section-head {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 2px 6px;
}

.section-head>div {
  display: flex;
  align-items: baseline;
  gap: 10px;
}

.section-head strong {
  font-size: 14px;
}

.section-head span {
  color: #8a96a5;
  font-size: 12px;
}

.scope-table-host {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.scope-table-host>>>.el-table {
  height: 100% !important;
}

.scope-table-host>>>.el-table__header-wrapper {
  overflow: hidden !important;
}

.scope-table-host>>>.el-table--scrollable-y .el-table__body-wrapper {
  overflow-x: hidden !important;
}

.scope-table-host>>>.el-table__body-wrapper {
  overflow-y: auto !important;
}

.scope-table>>>.el-table__row {
  cursor: pointer;
}

.scope-table {
  width: 100%;
}

.scope-table>>>.el-table__header th,
.scope-table>>>.el-table__body td {
  padding-left: 4px;
  padding-right: 4px;
}

.scope-table>>>.el-table__header .cell,
.scope-table>>>.el-table__body .cell {
  padding-left: 2px;
  padding-right: 2px;
  white-space: nowrap;
}

.scope-name {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-weight: 600;
}

.scope-name.building {
  color: #1f3a5f;
}

.scope-name.floor {
  color: #334155;
}

.scope-name.room {
  color: #64748b;
  font-weight: 500;
}

.detail-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.detail-search-input {
  width: 220px;
  flex: 0 0 220px;
}

.student-avatar,
.student-photo {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.student-avatar {
  color: #0f766e;
  background: #ccfbf1;
  font-size: 12px;
  font-weight: 700;
}

.student-photo {
  overflow: hidden;
  object-fit: cover;
  background: #f1f5f9;
  cursor: pointer;
}

.student-photo-error {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #94a3b8;
  font-size: 16px;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;
}

.detail-pager {
  margin-top: 14px;
  padding-top: 2px;
}

@media (max-width: 1480px) {
  .metric-groups {
    grid-template-columns: 1fr 1fr;
  }

  .metric-group-head span {
    white-space: normal;
  }

  .metric-group.other {
    grid-column: 2;
    grid-row: 1;
  }
}

@media (max-width: 1280px) {
  .dorm-building-sidebar {
    width: 240px;
    min-width: 240px;
  }

  .metric-groups {
    grid-template-columns: 1fr;
  }

  .metric-group.evening {
    grid-column: span 1;
  }

  .metric-group.other {
    grid-column: auto;
    grid-row: auto;
  }

  .section-head span {
    display: none;
  }

  .scope-table-host>>>.el-table--scrollable-y .el-table__body-wrapper {
    overflow-x: auto !important;
  }
}
</style>

<style>
/* 明细弹窗挂到 body，复用 V3 弹窗高度。最后修改：2026-08-31 */
.building-detail-dialog.metric-detail-dialog {
  margin-top: 6vh !important;
}

.building-detail-dialog.metric-detail-dialog .el-dialog__body {
  padding-top: 16px;
  padding-bottom: 12px;
}

.building-detail-dialog .metric-detail-table-wrap {
  height: 460px;
  min-height: 460px;
  overflow: hidden;
}

.building-detail-dialog .metric-detail-table {
  height: 100%;
}

.building-detail-dialog .metric-detail-table .el-table__body-wrapper {
  overflow-x: auto !important;
  overflow-y: auto !important;
}

.building-detail-dialog .metric-detail-table .el-table__empty-block {
  min-height: 380px;
}
</style>
